import React from "react";
import PropTypes from "prop-types";
import {
  CssBaseline,
  Drawer,
  Hidden,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,Typography,
  Avatar,
  Box,Grid,
  Collapse,Icon,
} from "@material-ui/core";
import {
  Home as HomeIcon,
  NoteAdd as NoteAddIcon,
  Event as EventIcon,
  ExpandLess,
  Message,
  ExpandMore,Dashboard,AccountBox,SupervisorAccount,
} from "@material-ui/icons";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import NavItem from "./NavItem";
import {USER_ROLE} from '../components/security/UserRole';

const drawerWidth = 260;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    background: "#e5edf3",
  },
  drawer: {
    [theme.breakpoints.up("md")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  profileContainer: {
    margin: theme.spacing(3),
  },
  profileContent: {
    padding: theme.spacing(2),
    background: theme.sideNavbar.activeNav.color,
    color: theme.sideNavbar.activeNav.contrastText,
    borderRadius : "10px"
  },
  drawerPaper: {
    width: drawerWidth,
    background: theme.sideNavbar.background.color,
    color: theme.sideNavbar.background.contrastText,
  },
  menu: {
    background: theme.sideNavbar.background.color,
    color: theme.sideNavbar.background.contrastText,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  activeMenu: {
    background: theme.sideNavbar.activeNav.color,
    color: theme.sideNavbar.activeNav.contrastText,
  },
  menuIcon : {
    color : theme.sideNavbar.background.contrastText,
    '&:hover': {
      color : theme.sideNavbar.background.contrastText,
    },
  },
  activeCollapse: {
    background: '#304161',
    color: theme.sideNavbar.activeNav.contrastText,
  },
  
}));

function AppSideNavBar(props) {
  const { window } = props;
  const classes = useStyles();
  const theme = useTheme();
  const user = useSelector((state) => state.authentication.user);
  const [opnedMenuIndex, setOpnedMenuIndex] = React.useState(0);

  const handleMenuClick = (index) => {
    if (opnedMenuIndex == index) {
      setOpnedMenuIndex(0);
    } else {
      setOpnedMenuIndex(index);
    }
  };
  const mobileOpen = props.mobileOpen;
  const patientMenu = (
    <List >
      <NavItem href={"/home"} title={"Dashboard"} icon={Dashboard} />
      <NavItem href={"/documents"} title={"Documents"} icon={NoteAddIcon} />
      <NavItem href={"/patient/actionitems"} title={"Action Items"} icon={NoteAddIcon} />
      
      <ListItem button onClick={() => handleMenuClick(2)} className={classes.menuIcon}>
        <ListItemIcon className={classes.menuIcon}>
          <EventIcon size="20" />
        </ListItemIcon>
        <ListItemText primary="Appointments" />
        {opnedMenuIndex === 2 ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={opnedMenuIndex === 2} timeout="auto" unmountOnExit>
        <List component="div" disablePadding >
        <NavItem href={"/appointments/new"} title={"New Appointment"} />
          <NavItem href={"/appointments"} title={"Today's Appointment"} />
          <NavItem href={"/appointments/tomorrow"} title={"Tomorrow's Appointments"} />
          <NavItem href={"/appointments/weekly"} title={"This Week's Appointments"} />
          <NavItem href={"/appointments/past"} title={"Past Appointment"} />
          <NavItem href={"/appointments/future"} title={"Future Appointment"} />
          <NavItem href={"/appointments/calendar"} title={"Appointment Calendar"} />
        </List>
      </Collapse>
    </List>
  );
  const doctorMenu = (
    <List>
      <NavItem href={"/doctor/home"} title={"Dashboard"} icon={Dashboard} />
      <NavItem href={"/patient"} title={"Patient Search"} icon={NoteAddIcon} />
      <NavItem href={"/admin/sms"} title={"Send SMS"} icon={Message} />
      <ListItem button onClick={() => handleMenuClick(2)} className={classes.menuIcon}>
        <ListItemIcon className={classes.menuIcon}>
          <EventIcon size="20" />
        </ListItemIcon>
        <ListItemText primary="Appointments" />
        {opnedMenuIndex === 2 ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={opnedMenuIndex === 2} timeout="auto" unmountOnExit>
        <List component="div" disablePadding >
          <NavItem href={"/appointments/new"} title={"New Appointment"} />
          <NavItem href={"/doctor/block"} title={"Block my schedule"} />
          <NavItem href={"/appointments"} title={"Todays Appointment"} />
          <NavItem href={"/appointments/tomorrow"} title={"Tomorrow's Appointments"} />
          <NavItem href={"/appointments/weekly"} title={"This Week's Appointments"} />
          <NavItem href={"/appointments/past"} title={"Past Appointment"} />
          <NavItem href={"/appointments/future"} title={"Future Appointment"} />
          <NavItem href={"/appointments/pending"} title={"Confirmation Pending"} />
          <NavItem href={"/appointments/calendar"} title={"Appointment Calendar"} />
        </List>
      </Collapse>
      <ListItem button onClick={() => handleMenuClick(3)} className={classes.menuIcon}>
        <ListItemIcon className={classes.menuIcon}>
          <EventIcon size="20" />
        </ListItemIcon>
        <ListItemText primary="Documents" />
        {opnedMenuIndex === 3 ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={opnedMenuIndex === 3} timeout="auto" unmountOnExit>
        <List component="div" disablePadding >
          <NavItem href={"/documents"} title={"Documents"} />
          <NavItem href={"/document/assign"} title={"Assign Documents"} />
        </List>
      </Collapse>

      
    </List>
  );
  const adminMenu = (
    <List>
      <NavItem href={"/admin/home"} title={"Dashboard"} icon={Dashboard} />
      <NavItem href={"/admin"} title={"Admin"} icon={SupervisorAccount} />
      <NavItem href={"/admin/hcp"} title={"HCP Admin"} icon={SupervisorAccount} />
      <NavItem href={"/patient"} title={"Patient"} fontAwesomeIcon = {"user-injured"}/>
      <NavItem href={"/doctor"} title={"Doctor"} fontAwesomeIcon = {"hospital-user"} />
      <NavItem href={"/admin/dynamicform"} title={"Form Creation"} icon = {NoteAddIcon}/>
      <NavItem href={"/admin/sms"} title={"Send SMS"} icon={Message} />
      <ListItem button onClick={() => handleMenuClick(3)} className={classes.menuIcon}>
        <ListItemIcon className={classes.menuIcon}>
          <EventIcon size="20" />
        </ListItemIcon>
        <ListItemText primary="Documents" />
        {opnedMenuIndex === 3 ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={opnedMenuIndex === 3} timeout="auto" unmountOnExit>
        <List component="div" disablePadding >
          <NavItem href={"/documents"} title={"Documents"} />
          <NavItem href={"/document/assign"} title={"Assign Documents"} />
        </List>
      </Collapse>
      <ListItem button onClick={() => handleMenuClick(2)} className={classes.menuIcon}>
        <ListItemIcon className={classes.menuIcon}>
          <EventIcon size="20" />
        </ListItemIcon>
        <ListItemText primary="Appointments" />
        {opnedMenuIndex === 2 ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={opnedMenuIndex === 2} timeout="auto" unmountOnExit>
        <List component="div" disablePadding >
          <NavItem href={"/appointments/new"} title={"New Appointment"} />
          <NavItem href={"/doctor/block"} title={"Block doctor schedule"} />
          <NavItem href={"/appointments"} title={"Todays Appointment"} />
          <NavItem href={"/appointments/tomorrow"} title={"Tomorrow's Appointments"} />
          <NavItem href={"/appointments/weekly"} title={"This Week's Appointments"} />
          <NavItem href={"/appointments/past"} title={"Past Appointment"} />
          <NavItem href={"/appointments/future"} title={"Future Appointment"} />
          <NavItem href={"/appointments/pending"} title={"Confirmation Pending"} />
          <NavItem href={"/appointments/calendar"} title={"Appointment Calendar"} />
        </List>
      </Collapse>
    </List>
  );

  const hcpAdminMenu =(
    <List>
      <NavItem href={"/patient"} title={"Patient"} fontAwesomeIcon = {"user-injured"}/>
      <NavItem href={"/doctor"} title={"Doctor"} fontAwesomeIcon = {"hospital-user"} />
      <NavItem href={"/admin/sms"} title={"Send SMS"} icon={Message} />
      <ListItem button onClick={() => handleMenuClick(2)} className={classes.menuIcon}>
        <ListItemIcon className={classes.menuIcon}>
          <EventIcon size="20" />
        </ListItemIcon>
        <ListItemText primary="Appointments" />
        {opnedMenuIndex === 2 ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={opnedMenuIndex === 2} timeout="auto" unmountOnExit>
        <List component="div" disablePadding >
          <NavItem href={"/appointments/new"} title={"New Appointment"} />
          <NavItem href={"/doctor/block"} title={"Block doctor schedule"} />
          <NavItem href={"/appointments"} title={"Todays Appointment"} />
          <NavItem href={"/appointments/tomorrow"} title={"Tomorrow's Appointments"} />
          <NavItem href={"/appointments/weekly"} title={"This Week's Appointments"} />
          <NavItem href={"/appointments/past"} title={"Past Appointment"} />
          <NavItem href={"/appointments/future"} title={"Future Appointment"} />
          <NavItem href={"/appointments/pending"} title={"Confirmation Pending"} />
          <NavItem href={"/appointments/calendar"} title={"Appointment Calendar"} />
        </List>
      </Collapse>
      <ListItem button onClick={() => handleMenuClick(3)} className={classes.menuIcon}>
        <ListItemIcon className={classes.menuIcon}>
          <EventIcon size="20" />
        </ListItemIcon>
        <ListItemText primary="Documents" />
        {opnedMenuIndex === 3 ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={opnedMenuIndex === 3} timeout="auto" unmountOnExit>
        <List component="div" disablePadding >
          <NavItem href={"/documents"} title={"Documents"} />
          <NavItem href={"/document/assign"} title={"Assign Documents"} />
        </List>
      </Collapse>
    </List>
  );

  const drawer = (
    <div>
      <Box>
        {/* <Avatar variant="rounded" className={classes.rounded}>
        <AssignmentIcon />
      </Avatar> */}

<Box className={classes.profileContainer}>
        <Grid container direction="row" justify="center" alignItems="center" className={classes.profileContent}>
          <Grid item>
            <Avatar alt="User Profile" src={user.avatar} />
          </Grid>
          <Grid item style={{paddingLeft:theme.spacing(2)}}>
            <Typography variant="subtitle2" color="default">{user.firstName +' '+user.lastName}</Typography>
          </Grid>
        </Grid>
        </Box>
        <Box>
          <List>
            <ListItem button onClick={() => handleMenuClick(1)} className={classes.menuIcon}>
              <ListItemIcon className={classes.menuIcon}>
                <AccountBox size="20" />
              </ListItemIcon>
              <ListItemText primary="Account" />
              {opnedMenuIndex === 1 ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={opnedMenuIndex === 1} timeout="auto" unmountOnExit>
              <List component="div" disablePadding className={classes.activeCollapse}>
              {user.userRole === USER_ROLE.PATIENT ? <NavItem href={"/profile"} title={"Profile"}/> : <></>}
              {user.userRole === USER_ROLE.DOCTOR ? <NavItem href={"/doctor/profile"} title={"Profile"}/> : <></>}
              {user.userRole === USER_ROLE.SYSTEM_ADMIN ? <NavItem href={"/admin/profile"} title={"Profile"}/> : <></>}
              {user.userRole === USER_ROLE.HCP_ADMIN ? <NavItem href={"/admin/profile"} title={"Profile"}/> : <></>}
              <NavItem
                  href={"/secretquestion"}
                  title={"Secret Question"}
                />
              <NavItem
                  href={"/change-password"}
                  title={"Change password"}
                />
                <NavItem href={"/login"} title={"Logout"}  />
              </List>
            </Collapse>
          </List>
        </Box>
        <Box sx={{ p: 2 }}>
          {user.userRole === USER_ROLE.PATIENT ? patientMenu : <></>}
          {user.userRole === USER_ROLE.DOCTOR ? doctorMenu : <></>}
          {user.userRole === USER_ROLE.SYSTEM_ADMIN ? adminMenu : <></>}
          {user.userRole === USER_ROLE.HCP_ADMIN ? hcpAdminMenu : <></>}
        </Box>
        <Box sx={{ flexGrow: 1 }} />
      </Box>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <div className={classes.root}>
      <CssBaseline />
      <nav className={classes.drawer} aria-label="mailbox folders">
        <Hidden mdUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === "rtl" ? "right" : "left"}
            open={props.mobileOpen}
            onClose={props.handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            color="primary"
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css">
          <Drawer
            color="primary"
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
    </div>
  );
}

AppSideNavBar.propTypes = {
  window: PropTypes.func,
};

export default AppSideNavBar;
